const needFetchFlagsActions = {
  NEED_FETCH_FLAGS_PROP_UPDATE: 'NEED_FETCH_FLAGS_PROP_UPDATE'
};
export default needFetchFlagsActions;
